import { IGeocodeForSearchResponse, IGeoDetail } from 'shared/types/geoSuggest';

export function getRegion(result: IGeocodeForSearchResponse) {
  return (
    result.details &&
    result.details.reduce((acc: IGeoDetail | undefined, value) => {
      return value.locationInfo ? value : acc;
    }, undefined)
  );
}
